<template>
  <b-card>
    <b-overlay
      :show="loading"
      variant="white"
      spinner-variant="primary"
      :opacity=".8"
    >
      <div class="d-flex justify-content-end">
        <b-dropdown
          id="dropdown-form"
          ref="dropdown"
          class="mr-1"
          right
          no-flip
          variant="secondary"
          text="Фильтр"
        >
          <b-dropdown-form
            class="py-1"
            @submit.prevent
          >
            <b-form-group
              label="По Ф.И.О."
              label-for="dropdown-form-full_name"
              @submit.prevent.stop
            >
              <b-form-input
                id="dropdown-form-full_name"
                v-model="filters.full_name"
                size="sm"
              />
            </b-form-group>

            <b-form-group
              label="Город:"
              label-for="city_id"
            >
              <v-select
                v-model="filters.city_id"
                label="name"
                :reduce="option => option.id"
                :options="citiesList"
              />
            </b-form-group>

            <b-form-group
              label="Тип"
              label-for="dropdown-form-per-page"
              @submit.prevent.stop
            >
              <b-form-select
                id="dropdown-form-type"
                v-model="filters.type"
                size="sm"
                value-field="id"
                text-field="value"
                :options="[{id: null, value: '----------'}, ...DoctorReviewsConstants.REVIEW_TYPE_LIST]"
              />
            </b-form-group>

            <b-form-group
              label="Статус"
              label-for="dropdown-form-status"
              @submit.prevent.stop
            >
              <b-form-select
                id="dropdown-form-status"
                v-model="filters.status"
                size="sm"
                value-field="id"
                text-field="value"
                :options="[{id: null, value: '----------'}, ...DoctorReviewsConstants.REVIEW_STATUS_LIST]"
              />
            </b-form-group>

            <b-form-group
              label="Кол-во на странице"
              label-for="dropdown-form-per-page"
              @submit.prevent.stop
            >
              <b-form-select
                id="dropdown-form-per-page"
                v-model="filters.perPage"
                size="sm"
                :options="[10, 20, 50, 100, 500]"
              />
            </b-form-group>

            <b-button-group>
              <b-button
                variant="primary"
                size="sm"
                @click="doApplyFilters"
              >
                Применить
              </b-button>
              <b-button
                variant="outline-secondary"
                size="sm"
                @click="doResetFilters"
              >
                Сбросить
              </b-button>
            </b-button-group>
          </b-dropdown-form>
        </b-dropdown>
        <router-link :to="{name: 'doctors-reviews-create'}">
          <b-button variant="primary">
            Создать
          </b-button>
        </router-link>
      </div>

      <div
        class="d-flex"
        :class="selectedRows.length > 0 ? 'justify-content-between' : 'justify-content-end'"
      >
        <div
          v-if="selectedRows.length > 0"
          class="d-flex align-items-center"
        >
          <b-dropdown
            id="dropdown-form1"
            ref="dropdown"
            size="sm"
            right
            variant="warning"
            :text="`Действия c (${selectedRows.length})`"
          >
            <b-dropdown-item
              variant="success"
              @click="actionDropDownCheckbox(selectedRows, '/doctor_reviews/actions/show', 'одобрить')"
            >
              Одобрить
            </b-dropdown-item>
            <b-dropdown-item @click="actionDropDownCheckbox(selectedRows, '/doctor_reviews/actions/hide','отклонить')">
              Отклонить
            </b-dropdown-item>
            <b-dropdown-item
              variant="danger"
              @click="actionDropDownCheckbox(selectedRows, '/doctor_reviews/actions/delete', 'удалить')"
            >
              Удалить
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <data-table
        :columns="columns"
        :rows.sync="rows"
        :settings="settings"
        :dev-logs="false"
        @updateFilter="doUpdateFilter"
      >

        <template
          slot="table-column"
          slot-scope="props"
        >
          <div
            v-if="props.column.label === 'checkbox'"
            class="text-center"
          >
            <b-form-checkbox
              v-model="selectAll"
            />
          </div>
          <div
            v-else
            class="text-center"
          >
            {{ props.column.label }}
          </div>
        </template>

        <template v-slot:table-row="item">
          <div
            v-if="item.column.field === 'checkbox'"
            class="text-center"
          >
            <b-form-checkbox
              v-model="selectedRows"
              :value="item.row.id"
            />
          </div>
          <div
            v-else-if="item.column.field === 'type'"
            class="text-center"
          >
            <span
              v-if="item.row.type === DoctorReviewsConstants.REVIEW_TYPE_IDS.REVIEW_TYPE_POSITIVE"
              v-b-tooltip.hover.v-success
              title="Позитивный"
            >
              <feather-icon
                icon="SquareIcon"
                class="text-success fill-current"
              />
            </span>
            <span
              v-else-if="item.row.type === DoctorReviewsConstants.REVIEW_TYPE_IDS.REVIEW_TYPE_NEUTRAL"
              v-b-tooltip.hover.v-warning
              title="Нейтральный"
            >
              <feather-icon
                icon="SquareIcon"
                class="text-warning fill-current"
              />
            </span>
            <span
              v-else-if="item.row.type === DoctorReviewsConstants.REVIEW_TYPE_IDS.REVIEW_TYPE_NEGATIVE"
              v-b-tooltip.hover.v-danger
              title="Негативный"
            >
              <feather-icon
                icon="SquareIcon"
                class="text-danger fill-current"
              />
            </span>
            <span v-else>—</span>
          </div>
          <div
            v-else-if="item.column.field === 'doctor_name'"
            class="text-center"
          >
            <router-link :to="{name: 'doctors-update', params: {id: item.row.doctor.id}}">
              {{ item.row.doctor.full_name }}
            </router-link>
          </div>
          <div
            v-else-if="item.column.field === 'description'"
            class="text-center"
          >
            <div style="width: auto; max-width: 450px">
              {{ item.row.description }}
            </div>
          </div>
          <div
            v-else-if="item.column.field === 'status'"
            class="text-center"
          >
            <span
              v-if="item.row.status === DoctorReviewsConstants.REVIEW_STATUS_IDS.REVIEW_STATUS_REJECTED"
              class="text-danger"
            >{{ DoctorReviewsConstants.REVIEW_STATUS_LIST[item.row.status].value }}</span>
            <span
              v-else-if="item.row.status === DoctorReviewsConstants.REVIEW_STATUS_IDS.REVIEW_STATUS_APPROVED"
              class="text-success"
            >
              {{ DoctorReviewsConstants.REVIEW_STATUS_LIST[item.row.status].value }}
            </span>
            <span
              v-else-if="item.row.status === DoctorReviewsConstants.REVIEW_STATUS_IDS.REVIEW_STATUS_MODERATING"
              class="text-warning"
            >
              {{ DoctorReviewsConstants.REVIEW_STATUS_LIST[item.row.status].value }}
            </span>
            <span v-else>—</span>
          </div>
          <div
            v-else-if="item.column.field === 'action'"
            class="text-center"
          >
            <router-link :to="{name: 'doctors-reviews-update', params: {id: item.row.id}}">
              <b-button
                variant="flat-warning"
                class="btn-icon"
              >
                <feather-icon
                  icon="Edit3Icon"
                  class="text-warning"
                />
              </b-button>
            </router-link>

            <b-button
              variant="flat-danger"
              class="btn-icon"
              @click="objectDelete(item.row.id)"
            >
              <feather-icon
                icon="Trash2Icon"
                class="text-danger"
              />
            </b-button>
          </div>
          <div
            v-else
            class="text-center"
          >
            {{ item.formattedRow[item.column.field] }}
          </div>
        </template>
      </data-table>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BDropdown,
  BDropdownForm,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormCheckbox,
  BOverlay,
  VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import _ from 'lodash'
import DataTable from '@/components/DataTable.vue'
import axiosIns from '@/libs/axios'
import { rowsObjectConverter, settingsObjectConverter } from '@/helpers/dataTableHelper'
import dataTableMixin from '@/mixins/dataTableMixin'
import DoctorReviewsConstants from '@/consts/doctorReviews'

export default {
  name: 'DoctorsReviewsList',
  components: {
    BCard,
    BFormGroup,
    BDropdown,
    BDropdownForm,
    BDropdownItem,
    BButton,
    BButtonGroup,
    BFormSelect,
    BOverlay,
    BFormInput,
    BFormCheckbox,
    DataTable,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [
    dataTableMixin,
  ],
  metaInfo: {
    title: 'Список отзывов для врачей',
  },
  data() {
    return {
      loading: true,
      filterOnURL: false,
      selectedRows: [],
      selectAll: false,
      columns: [
        {
          label: 'checkbox',
          field: 'checkbox',
        },
        {
          label: 'ID',
          field: 'id',
        },
        {
          label: 'Тип',
          field: 'type',
        },
        {
          label: 'Ф.И.О.',
          field: 'doctor_name',
        },
        // {
        //   label: 'Город',
        //   field: rowObj => (rowObj.doctor.city_id !== null && rowObj.doctor.city_id ? this.getCityName(rowObj.doctor.city_id) : '—'),
        // },
        {
          label: 'Отзыв',
          field: 'description',
        },
        {
          label: 'Статус',
          field: 'status',
        },
        {
          label: 'Дата создания',
          field: rowObj => (rowObj.created_at !== null ? this.formateDate(rowObj.created_at) : '—'),
        },
        {
          label: 'Действия',
          field: 'action',
        },
      ],
      citiesList: [],
      DoctorReviewsConstants,
    }
  },
  watch: {
    selectAll: {
      handler(state) {
        if (state) {
          this.selectedRows = _.map(this.rows, 'id')
        } else {
          this.selectedRows = []
        }
      },
    },
  },
  beforeMount() {
    this.setDefaultFilter({
      status: DoctorReviewsConstants.REVIEW_STATUS_IDS.REVIEW_STATUS_MODERATING,
      manager_id: null,
      perPage: 50,
    }, () => { this.setFilterToDefault() })

    Promise.all([
      this.doLoadCities(),
    ]).then(() => {
      Promise.all([
        this.doLoadDoctorReviews(),
      ]).then(() => {
        this.loading = false
      })
    })

    // Пушим промисы фильтров, чтоб вызывать методы
    this.filterPromises.push(() => this.doLoadDoctorReviews())
  },
  methods: {
    async doLoadDoctorReviews() {
      const res = await axiosIns({
        method: 'GET',
        url: '/doctor_reviews/list',
        params: _.merge(this.filters),
      })

      this.$set(this, 'settings', settingsObjectConverter(res.data.data))
      this.$set(this, 'rows', rowsObjectConverter(res.data.data))

      return res
    },
    async doLoadCities() {
      const res = await axiosIns({
        method: 'GET',
        url: '/cities/options',
      })

      this.citiesList = res.data.data

      return res
    },
    getCityName(cityId) {
      if (this.citiesList.length === 0) return '—'

      // eslint-disable-next-line radix
      return _.find(this.citiesList, city => city.id === parseInt(cityId)).name ?? '—'
    },
    async objectDelete(id) {
      const modalResult = await this.$swal({
        title: '',
        text: 'Вы уверены что хотите удалить эту запись?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })

      if (modalResult.value) {
        await axiosIns({
          method: 'DELETE',
          url: `/doctor_reviews/${id}/delete`,
        })

        await this.doLoadDoctorReviews()
        this.$swal({
          icon: 'success',
          title: 'Удалено!',
          text: '',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }
    },
    async actionDropDownCheckbox(ids, url, message) {
      const modalResult = await this.$swal({
        title: '',
        text: `Вы уверены что хотите ${message}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })

      if (modalResult.value) {
        const res = await axiosIns({
          method: 'POST',
          url: `${url}`,
          data: { ids },
        })
        if (res.data.status === 'success') {
          this.loading = true
          await this.doLoadDoctorReviews()
          this.loading = false
          this.selectedRows = []
          this.sendToast({
            title: 'Успех!',
            icon: 'CheckCircleIcon',
            text: 'Успех!',
            variant: 'success',
          })
        } else {
          this.sendToast({
            title: '',
            icon: 'AlertCircleIcon',
            text: 'Ошибка, попробуй снова!',
            variant: 'danger',
          })
        }
      }
    },
    formateDate(date) {
      if (!date) {
        return '—'
      }

      const datetime = new Date(date.replace(' ', 'T'))
      const dd = String(datetime.getDate()).padStart(2, '0')
      const mm = String(datetime.getMonth() + 1).padStart(2, '0')
      const yyyy = datetime.getFullYear()

      return `${dd}-${mm}-${yyyy}`
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
